import { statementStatusMeta } from "../../constants/statementStatus";

// Reuse the exact status symbols from the Invoice Statements page rather than inventing new
// ones. Map the radar's 3 line states onto the established statement-status vocabulary:
//   matched   -> reconciled (green FaCheckCircle)
//   partial   -> partial    (orange FaMinusCircle)
//   unmatched -> pending    (gray  FaRegCircle)
const STATUS_KEY = { matched: "reconciled", partial: "partial", unmatched: "pending" };
const LABEL = { matched: "Matched", partial: "Partial", unmatched: "Unmatched" };

export default function StatusPill({ status }) {
   const meta = statementStatusMeta(STATUS_KEY[status] || "pending");
   const Icon = meta.icon;
   return (
      <span title={LABEL[status] || "—"} style={{ display: "inline-flex", alignItems: "center" }}>
         <Icon color={meta.color} size={18} />
      </span>
   );
}
